export const newJob = 'new';
export const assigned = 'assigned';
export const inProgress = 'in progress';
export const completed = 'completed';
export const failed = 'failed';
export const verified = 'verified';
export const certified = 'certified';
export const invoiced = 'invoiced';
export const cancelled = 'cancelled';
